module.exports = __webpack_public_path__ + "media/images/delete-b34ca63810ccf47235bb651d3fde2e97.svg";